/**
 * Couvertures de l'espace apprenant (04/11/2026, demande du dirigeant : « un visuel, comme dans les pages Notion, pour
 * accueillir l'apprenant »). Galerie NEUTRE fournie par la plateforme : uniquement des dégradés et des motifs CSS tirés
 * de la palette « Skills4mation Vif » (docs/STYLE_VISUELS.md) — aucune image, aucun logo, aucune marque.
 *
 * Une couverture de galerie se désigne par son identifiant (`galerie:<id>`), une image déposée par le formateur par
 * `image`. Le fond CSS est appliqué tel quel par l'interface (`background`).
 */

export interface CouvertureGalerie {
  id: string;
  libelle: string;
  /** Valeur CSS `background` (dégradés, motifs) : pas d'URL, rien à charger. */
  fond: string;
}

export const COUVERTURES: readonly CouvertureGalerie[] = [
  {
    id: "sapin",
    libelle: "Sapin et surligneur (couleurs de l'application)",
    fond: "linear-gradient(120deg, oklch(39% 0.095 158) 0%, oklch(52% 0.12 158) 55%, oklch(84% 0.155 92) 100%)",
  },
  {
    id: "aurore",
    libelle: "Aurore (indigo et lagon)",
    fond: "linear-gradient(120deg, #4F46E5 0%, #0EA5E9 100%)",
  },
  {
    id: "lagon",
    libelle: "Lagon (bleu, sarcelle, menthe)",
    fond: "linear-gradient(120deg, #0EA5E9 0%, #14B8A6 55%, #10B981 100%)",
  },
  {
    id: "mangue",
    libelle: "Mangue (orange et framboise)",
    fond: "linear-gradient(120deg, #FF8A00 0%, #F43F5E 100%)",
  },
  {
    id: "crepuscule",
    libelle: "Crépuscule (nuit, indigo, violet)",
    fond: "linear-gradient(120deg, #16163A 0%, #4F46E5 55%, #A855F7 100%)",
  },
  {
    id: "pois",
    libelle: "Pois sur menthe",
    fond: "radial-gradient(circle at 50% 50%, rgba(255,255,255,0.32) 0 3px, transparent 4px) 0 0 / 26px 26px, linear-gradient(120deg, #10B981 0%, #14B8A6 100%)",
  },
  {
    id: "carnet",
    libelle: "Carnet ligné",
    fond: "repeating-linear-gradient(0deg, rgba(79,70,229,0.14) 0 1px, transparent 1px 28px), linear-gradient(180deg, #F7F7FF 0%, #E8E9FF 100%)",
  },
  {
    id: "quadrillage",
    libelle: "Quadrillage indigo",
    fond: "linear-gradient(rgba(255,255,255,0.12) 1px, transparent 1px) 0 0 / 32px 32px, linear-gradient(90deg, rgba(255,255,255,0.12) 1px, transparent 1px) 0 0 / 32px 32px, linear-gradient(135deg, #4F46E5 0%, #16163A 100%)",
  },
  {
    id: "halos",
    libelle: "Halos colorés",
    fond: "radial-gradient(circle at 15% 40%, rgba(255,138,0,0.55) 0, transparent 40%), radial-gradient(circle at 80% 30%, rgba(14,165,233,0.55) 0, transparent 45%), radial-gradient(circle at 55% 90%, rgba(168,85,247,0.5) 0, transparent 45%), #F7F7FF",
  },
];

export const COUVERTURE_PAR_DEFAUT = "sapin";

export function couvertureGalerie(id: string): CouvertureGalerie | undefined {
  return COUVERTURES.find((c) => c.id === id);
}
